// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","736":"vendor"}[chunkId] + "." + {"532":"f096b3192327ed8554ea","736":"b6d4802a7703159312b3"}[chunkId] + ".css";
};